// extracted by mini-css-extract-plugin
export var actionButton = "_kg-0";
export var fileInput = "_kg-2";
export var paperclip = "_kg-1";